<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(['confirm']);
</script>

<template>
  <ModalBase class="modals-confirm" :title="title">
    <div class="modals-confirm__container">
      <UiButton
        class="modals-confirm__button"
        type="button"
        theme="secondary"
        @click="emit('confirm')"
      >
        <span class="modals-confirm__font">
          {{ buttonText }}
        </span>
      </UiButton>
    </div>
  </ModalBase>
</template>

<style scoped lang="scss">
.modals-confirm {
  &__font {
    display: block;
    font-size: em(20);
    font-weight: 500;
    line-height: math.div(22, 20);
  }

  &__container {
    padding: em(12) em($modal-padding) em(31);

    @include media-breakpoint-down(sm) {
      padding: em(12) em($gap-sm) em($gap-sm);
    }
  }

  &__button {
    width: em(358);
    height: em(63);
    margin: 0 auto;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
}
</style>
